import { assertGlobalPresent, assertProvider, assertProviderManifest } from './assert.js';
import { isPenumbraManifest } from './manifest.js';
import { PenumbraSymbol } from './symbol.js';
/** Return the specified provider, without verifying anything. */
export const getPenumbraUnsafe = (penumbraOrigin) => window[PenumbraSymbol]?.[penumbraOrigin];
/** Return the specified provider after confirming presence of its manifest. */
export const getPenumbra = (penumbraOrigin) => assertProvider(penumbraOrigin);
/** Fetch the specified provider's manifest. */
export const getPenumbraManifest = async (penumbraOrigin, signal) => {
    const manifestJson = await assertProviderManifest(penumbraOrigin, signal);
    if (!isPenumbraManifest(manifestJson)) {
        throw new TypeError('Invalid manifest');
    }
    return manifestJson;
};
/** Fetch all manifests for all providers available on the page. */
export const getAllPenumbraManifests = (signal) => Object.fromEntries(Object.keys(assertGlobalPresent()).map(providerOrigin => [
    providerOrigin,
    getPenumbraManifest(providerOrigin, signal),
]));
export * from './error.js';
export { PenumbraState } from './state.js';
export { PenumbraSymbol } from './symbol.js';
